"use client"

import LoginForm from "../_components/LoginForm"
export default function LoginPage() {
  return (
    <main className="min-h-dvh w-full">
      <div className="mx-auto grid min-h-dvh w-full max-w-9xl grid-cols-1 lg:grid-cols-2">
        {/* Left: logo top-left + centered form */}
        <section className="relative flex min-h-dvh flex-col px-6 py-6 sm:px-8 lg:px-10">
          {/* Logo top-left */}
          <div className="flex items-center gap-3">
            <img src="/images/logo.svg" alt="Company logo" className="h-14 sm:h-16" />
          </div>

          {/* Centered form */}
          <div className="flex flex-1 items-center">
            <div className="mx-auto w-full max-w-md">
              <LoginForm />
            </div>
          </div>
        </section>

        {/* Right: hero image (hidden on mobile) */}
        <aside className="hidden items-center justify-center p-6 sm:p-8 lg:flex">
          <div className="relative h-[480px] w-[900px]  overflow-hidden rounded-3xl ">
            <img src="/images/loginbanner.png" alt="Workers loading truck" className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
          </div>
        </aside>
      </div>
    </main>
  )
}
